import {Component, Input, OnInit} from '@angular/core';
import {
  BerlinBrandenBurgVideotextAussichten, BerlinBrandenBurgVideotextVorhersagen, VideotextTagesAussicht
} from "../../../../../../../../model/vorhersagen/rbb-document";
import {MatTableDataSource} from "@angular/material/table";
import {newArray} from "@angular/compiler/src/util";
import {MesswertPaket} from "../../../../../../../../model/messwerte/messwert-paket";

@Component({
  selector: 'app-berlin-brandenburg-videotext-bericht',
  templateUrl: './berlin-brandenburg-videotext-bericht.component.html',
  styleUrls: ['./berlin-brandenburg-videotext-bericht.component.css', '../../../wetterbericht.component.css']
})
export class BerlinBrandenburgVideotextBerichtComponent{

  berlinBrandenburgVideotextAussichten: BerlinBrandenBurgVideotextAussichten;

  @Input()
  set setBerlinBrandenburgVideotextAussichten(berlinBrandenburgVideotextAussichten: BerlinBrandenBurgVideotextAussichten) {
    this.berlinBrandenburgVideotextAussichten = berlinBrandenburgVideotextAussichten;
    this.dataSource.data = [this.berlinBrandenburgVideotextAussichten?.tag02, this.berlinBrandenburgVideotextAussichten?.tag03, this.berlinBrandenburgVideotextAussichten?.tag04, this.berlinBrandenburgVideotextAussichten?.tag05, this.berlinBrandenburgVideotextAussichten?.tag06];
  }

  @Input()
  berlinBrandenburgVideotextVorhersagen?: BerlinBrandenBurgVideotextVorhersagen;

  dataSource = new MatTableDataSource<VideotextTagesAussicht>();
  displayedColumns = ['datum', 'maxTemp', 'minTemp', 'regen'];


}
